module.exports = __webpack_public_path__ + "media/images/content/icon_moto-f6d46f2a301a01581292fbe8c23e04f9.svg";